export default __webpack_public_path__ + "static/media/icon-youtube.a319330a.svg";